import Router from 'vue-router';
import Vue from 'vue';
import { ifAuthenticated, ifNotAuthenticated, isOwner } from './guard';

const AlarmContainer = () => import(/* webpackChunkName: "Alarm" */ '../views/AlarmContainer');
const AuthContainer = () => import(/* webpackChunkName: "Auth" */ '../views/AuthContainer');
const ContactsContainer = () => import(/* webpackChunkName: "Contacts" */ '../views/ContactsContainer');
const FindPhoneContainer = () => import(/* webpackChunkName: "FindPhone" */ '../views/FindPhoneContainer');
const HelperContainer = () => import(/* webpackChunkName: "Help" */ '../views/HelperContainer');
const MyPhoneContainer = () => import(/* webpackChunkName: "MyPhone" */ '../views/MyPhoneContainer');
const OwnerContainer = () => import(/* webpackChunkName: "Owner" */ '../views/OwnerContainer');
const PanelContainer = () => import(/* webpackChunkName: "Panel" */ '../views/PanelContainer');
const HistoryContainer = () => import(/* webpackChunkName: "History" */ '../views/HistoryContainer');
const MySOSContainer = () => import(/* webpackChunkName: "MySOS" */ '../views/MySOSContainer');
const MySettingsContainer = () => import(/* webpackChunkName: "MySettings" */ '../views/MySettingsContainer');
const MyHelpersContainer = () => import(/* webpackChunkName: "MyHelpers" */ '../views/MyHelpersContainer');
const DebugContainer = () => import(/* webpackChunkName: "Debug" */ '../views/DebugContainer');
const PersonalContainer = () => import(/* webpackChunkName: "Personal" */ '../views/PersonalContainer');
const NoPhoneContainer = () => import(/* webpackChunkName: "NoPhone" */ '../views/NoPhoneContainer');
const NotFoundContainer = () => import(/* webpackChunkName: "NotFound" */ '../views/NotFoundContainer');
const LoaderContainer = () => import(/* webpackChunkName: "Loader" */ '../views/LoaderContainer');

Vue.use(Router);

export default new Router({
  mode: 'history',
  routes: [
    {
      path: '/loader',
      name: 'LoaderContainer',
      component: LoaderContainer,
      beforeEnter: ifAuthenticated,
    }, {
      path: '/debug',
      name: 'DebugContainer',
      component: DebugContainer,
      beforeEnter: ifAuthenticated,
    }, {
      path: '/nophone',
      name: 'NoPhoneContainer',
      component: NoPhoneContainer,
      beforeEnter: ifAuthenticated,
    }, {
      path: '/',
      alias: '/login',
      name: 'AuthContainer',
      component: AuthContainer,
      beforeEnter: ifNotAuthenticated,
    }, {
      path: '/panel',
      name: 'PanelContainer',
      component: PanelContainer,
      beforeEnter: isOwner,
      children: [
        {
          path: 'owner',
          name: 'OwnerContainer',
          component: OwnerContainer,
          beforeEnter: isOwner,
          children: [
            {
              path: 'myphone',
              name: 'MyPhoneContainer',
              component: MyPhoneContainer,
            }, {
              path: 'contacts',
              name: 'ContactsContainer',
              component: ContactsContainer,
            }, {
              path: 'alarms',
              name: 'AlarmContainer',
              component: AlarmContainer,
            }, {
              path: 'sos',
              name: 'MySOSContainer',
              component: MySOSContainer,
            }, {
              path: 'settings',
              name: 'MySettingsContainer',
              component: MySettingsContainer,
            }, {
              path: 'finder',
              name: 'FindPhoneContainer',
              component: FindPhoneContainer,
            }, {
              path: 'helpers',
              name: 'MyHelpersContainer',
              component: MyHelpersContainer,
            }, {
              path: 'history',
              name: 'HistoryContainer',
              component: HistoryContainer,
            }, {
              path: '*',
              name: 'NotFoundContainer',
              component: NotFoundContainer,
            },
          ],
        }, {
          path: 'helper',
          name: 'HelperContainer',
          component: HelperContainer,
        }, {
          path: 'personal',
          name: 'PersonalContainer',
          component: PersonalContainer,
        }, {
          path: '*',
          name: 'NotFoundContainer',
          component: NotFoundContainer,
        },
      ],
    }, {
      path: '*',
      name: 'NotFoundContainer',
      component: NotFoundContainer,
    },
  ],
});



// WEBPACK FOOTER //
// ./src/router/index.js